module.exports = __webpack_public_path__ + "static/media/mockup-desktop.8fe224fe.png";